import React from 'react';
import CraftingCalculator from './components/CraftingCalculator';
import './App.css';

function App() {
  return (
    <div className="App">
      <CraftingCalculator />
    </div>
  );
}

export default App; 